import { MutationTree } from "vuex";
import { IDataProvider } from "@/store";
import { IDocumentTemplateState } from "@/store/modules/documentTemplate/state";
import DocumentTemplate from "@/types/documents/documentTemplate/DocumentTemplate";

export enum DocumentTemplateMutations {
  SET_ONE = "SET_ONE_NOMENCLATURE",
  SET_ALL = "SET_ALL_NOMENCLATURE",
  SET_LAZY_DATA = "SET_LAZY_DATA_NOMENCLATURE",
}

export const mutations: MutationTree<IDocumentTemplateState> = {
  [DocumentTemplateMutations.SET_ONE](state, payload: DocumentTemplate) {
    state.documentTemplate = payload;
  },
  [DocumentTemplateMutations.SET_ALL](state, payload: DocumentTemplate[]) {
    state.documentTemplates = payload;
  },
  [DocumentTemplateMutations.SET_LAZY_DATA](
    state,
    payload: IDataProvider<DocumentTemplate>
  ) {
    state.dataProvider = payload;
  },
};
